module.exports = __webpack_public_path__ + "media/Images/icon-coin-stack-1051961d783b846bbcb186a24f1f1ebf.svg";